import React from 'react'
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import Lightbox from 'yet-another-react-lightbox';
import Fullscreen from "yet-another-react-lightbox/plugins/fullscreen";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import Inline from "yet-another-react-lightbox/plugins/inline";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import "./wedding-album.css";

function importAll(r) {
    return r.keys().map(r);
}

function getImageName(path) {
    const match = path.match(/\/([^/.]+)\./);
    return match ? match[1] : null;
}

const preShowImages = [
    // "01_TIT07997", "02_TIT07990", "03_TIT08235", "04_TIT08237"
    // "TIT07257", "TIT07990", "TIT08463", "TIT07804"
]

const importImages = Array.from(
    new Map(
        importAll(
            require.context('./album', false, /\.(png|jpg|svg)$/)
        ).map(item => {
            const src = item.default || item;
            return [src, { src, alt: "ảnh cưới", imageName: getImageName(src) }];
        })
    ).values()
).sort((a, b) => a.imageName.localeCompare(b.imageName));

const imageMap = new Map(
    importImages.map(img => [img.imageName, img])
);

const images = [
    ...preShowImages.map(name => imageMap.get(name)).filter(Boolean),
    ...importImages.filter(img => !preShowImages.includes(img.imageName))
];
export default function WeddingAlbum() {
    return <div>
        <Lightbox
            styles={{ root: { 
                "--yarl__color_backdrop": "rgb(28, 24, 16)",
                // "--yarl__thumbnails_container_padding": 5,
                "--yarl__thumbnails_thumbnail_background": "rgba(196, 191, 152, 0.84)",
                "--yarl__thumbnails_thumbnail_gap": 0,
            } }}
            slides={images}
            plugins={[Thumbnails, Fullscreen, Inline, Zoom]}
            carousel={{
                padding: 0,
                spacing: 0,
            }}
            inline={{
                style: {
                    width: "100%",
                    maxWidth: "900px",
                    aspectRatio: "2 / 3",
                    margin: "0 auto",
                },
            }}
        />
    </div>
}
